// Top-level navigation state.
//
// `view` decides wizard vs. the app proper (App enforces the wizard
// while onboarding is incomplete, but lets the creator peek at the app
// via "Look around BKA" — that sets view to "app").
// `tab` is which dashboard tab shows once in the app.

import { create } from "zustand";

export type View = "wizard" | "app";
export type Tab = "compose" | "library" | "stats" | "settings";

export const TABS: { id: Tab; label: string }[] = [
  { id: "compose", label: "Compose" },
  { id: "library", label: "Library" },
  { id: "stats", label: "Stats" },
  { id: "settings", label: "Settings" },
];

interface NavState {
  view: View;
  tab: Tab;
  setView: (view: View) => void;
  setTab: (tab: Tab) => void;
}

export const useNavStore = create<NavState>((set) => ({
  view: "wizard",
  tab: "compose",
  setView: (view) => set({ view }),
  setTab: (tab) => set({ tab }),
}));
